export const CalenderComponentTranslations = {
    bookSession: {
        key: 'calendarComponent.labelsAndTitles.BOOK_SESSION',
    },
    mentor: {
        key: 'calendarComponent.labelsAndTitles.MENTOR'
    },
    slotDuration: {
        key: 'calendarComponent.labelsAndTitles.SLOT_DURATION'
    },
    myTimezone: {
        key: 'calendarComponent.labelsAndTitles.MY_TIMEZONE'
    },
    slotsAvailable: {
        key: 'calendarComponent.labelsAndTitles.SLOTS_AVAILABLE'
    },
    morning: {
        key: 'calendarComponent.labelsAndTitles.MORNING'
    },
    evening: {
        key: 'calendarComponent.labelsAndTitles.EVENING'
    },
    youName: {
        key: 'calendarComponent.labelsAndTitles.YOU_NAME'
    },
    yourEmail: {
        key: 'calendarComponent.labelsAndTitles.YOUR_EMAIL'
    },
    additionalNotes: {
        key: 'calendarComponent.labelsAndTitles.ADDITIONAL_NOTES'
    },
    enterName: {
        key: 'calendarComponent.labelsAndTitles.ENTER_NAME'
    },
    enterEmail: {
        key: 'calendarComponent.labelsAndTitles.ENTER_EMAIL'
    },
    enterNotes: {
        key: 'calendarComponent.labelsAndTitles.ENTER_NOTES'
    },
    book: {
        key: 'calendarComponent.labelsAndTitles.BOOK'
    },
    back: {
        key: 'calendarComponent.labelsAndTitles.BACK'
    },
    noSlots: {
        key: 'calendarComponent.labelsAndTitles.NO_SLOTS'
    },
    sessionDate: {
        key: 'calendarComponent.labelsAndTitles.SESSION_DATE'
    },
    sessionTime: {
        key: 'calendarComponent.labelsAndTitles.SESSION_TIME'
    },
    afternoon: {
        key: 'calendarComponent.labelsAndTitles.AFTERNOON'
    }
}
 